import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

interface DataInterface {
  title: string;
  subtitle: string;
  btnText: string;
}

@Component({
  selector: 'eb-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, TranslateModule],
})
export class AlertDialogComponent {
  data = inject<DataInterface>(MAT_DIALOG_DATA);
  private readonly cdr = inject(ChangeDetectorRef);
  dialogRef = inject<MatDialogRef<AlertDialogComponent>>(MatDialogRef);

  onClose(evt: MouseEvent): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.dialogRef.close(true);
    this.cdr.markForCheck();
  }
}
